<div [class]="skinName">
  @if (step == 1) {
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.['plans.choose_plan.text'] }}</h2>
  }
  <!-- <h2 class="uk-modal-title" *ngIf="step == 2">
{{configService.localeKeys?.['common_keys.are_you_sure.text']}}</h2> -->
@if (step == 3) {
  <div>
    <app-success icon="/branding/theme/assets/static_assets/ic-success.svg" [bottomtext]="" [haslottie]="'true'">
    </app-success>
  </div>
}
@if (step == 3) {
  <h2 class="uk-modal-title change-title">{{ configService.localeKeys?.payment_plance_changed_message }}</h2>
}
<!--p class="plan-text mt-0" *ngIf="step == 1">
{{ configService.localeKeys?.select_plan_below }}
</p-->
@if (step == 1) {
  <div class="input-container">
    <div id="select-plan" [ngClass]="subscriptions.length == 1? 'select-plan-single' : 'select-plan-more'">
      @if(!avodPlans && !svodPlans){
        <div class="loader">
          <img class="loader-img loader-size" src="branding/theme/assets/static_assets/ic-app-loader.svg" alt="">
      </div>
      }
      @if(avodPlans?.length || svodPlans?.length){
        <div id="select-plan-pad">
          @if (avodPlans?.length) {
            <div id="plan-details" [ngClass]="{'display-contents': subscriptions.length == 1}" class="avodsvod-details">
              @if (svodPlans?.length && avodPlans?.length) {
                <div class="plan-plantype" >
                  <p class="plantype-title">{{configService.localeKeys?.['plans_listing.with_ads.text'] || 'With Ads'}}</p>
                  <p class="plantype-info">{{configService.localeKeys?.['plans_listing.download_promo_line.text'] || 'Download and watch on the go'}}</p>
                </div>
              }
              @for (plan of avodPlans; track plan) {
                <div id="plan-info" [ngClass]="{'selectedPlan': (selectedPlan && selectedPlan.subscription_id == plan.subscription_id), 'current-subscription': (currentPlan && currentPlan?.subscription_id == plan.subscription_id), 'disabled': (+(plan?.original_amount) < +(currentPlan?.original_amount) || isAvodSubscribed || (plan?.free_plan && currentPlan?.subscription_id != plan.subscription_id) || (currentPlan?.cancel_subscription == 1 && currentPlan?.subscription_id != plan.subscription_id))}" (click)="selectPlan(plan)">
                  @if (currentPlan && currentPlan?.subscription_id == plan.subscription_id) {
                    <div class="current-subscription-title"><span>{{configService.localeKeys?.['plans_listing.current_plan.text'] || 'current plan'}}</span></div>
                  }
                  <app-card-plan [plan]="plan" [selectedPlan]="selectedPlan" ></app-card-plan>
                </div>
              }
            </div>
          }
          @if (svodPlans?.length) {
            <div id="plan-details" [ngClass]="{'display-contents': subscriptions.length == 1}" class="avodsvod-details">
              @if (svodPlans?.length && avodPlans?.length) {
                <div class="plan-plantype">
                  <p class="plantype-title">{{configService.localeKeys?.['plans_listing.ads_free.text'] || 'Ads Free'}}</p>
                  <p class="plantype-info">{{configService.localeKeys?.['plans.subscription_plan_tagline.text'] || 'Download and watch on the go2'}}</p>
                </div>
              }
              @for (plan of svodPlans; track plan) {
                <div id="plan-info" [ngClass]="{'selectedPlan': (selectedPlan && selectedPlan.subscription_id == plan.subscription_id), 'current-subscription': (currentPlan && currentPlan?.subscription_id == plan.subscription_id),'disabled': (+(plan?.original_amount) < +(currentPlan?.original_amount)) || (plan?.free_plan && currentPlan?.subscription_id != plan.subscription_id) || (currentPlan?.cancel_subscription == 1 && currentPlan?.subscription_id != plan.subscription_id) }" (click)="selectPlan(plan)">
                  @if (currentPlan && currentPlan?.subscription_id == plan.subscription_id) {
                    <div class="current-subscription-title"><span>{{configService.localeKeys?.['plans_listing.current_plan.text'] || 'current plan'}}</span></div>
                  }
                  <app-card-plan [plan]="plan" [selectedPlan]="selectedPlan" ></app-card-plan>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    @if (displayProratedData) {
      <div class="prorated-info">
        @if (!currentPlan?.free_plan) {
          <p>{{ configService.localeKeys?.plans_upgrade_plan_prorate_part1 ||'Since you upgraded to a higher package, you will currently pay'}} <span>{{proratedData?.payable_amount}}</span></p>
        }
        @if (!currentPlan?.free_plan) {
          <p> {{ configService.localeKeys?.plans_upgrade_plan_prorate_part2 || 'Starting'}} {{proratedData.conertedBillingDate}} {{configService.localeKeys?.plans_upgrade_plan_prorate_part3 || 'We will continue with'}} <span>{{proratedData?.next_billing_amount}}</span> {{selectedPlan?.plan_detail}}</p>
        }
        <button class="uk-button submit-btn" (click)="changePlanBtnClick()">{{configService.localeKeys?.['plans.upgrade_plan.btn'] || 'Upgrade Plan'}}</button>
      </div>
    }
    <div class="plan-btn-container">
      @if (currentPlan && currentPlan.user_type==1 && currentPlan.subscription_id && subscribedPlanId != currentPlan.subscription_id && updatedPayment==0 && !displayProratedData) {
        <button class="uk-button submit-btn" (click)="onPlanSwitch()">{{ configService.localeKeys?.['plans_listing.plan_switch.text']}}</button>
      }
      @if (currentPlan && currentPlan.cancel_subscription == 1 && subscribedPlanId && subscribedPlanId == currentPlan.subscription_id && currentPlan.subscription_can_resume==1 && updatedPayment==0 && !displayProratedData) {
        <button class="uk-button submit-btn" (click)="resumePlan()">{{ configService.localeKeys?.['plans.resume_subscription.text']}}</button>
      }
      @if (selectedPlan && selectedPlan.complete_payment==1 && updatedPayment==0) {
        <button class="uk-button submit-btn" (click)="checkout(selectedPlan,'invoice')">{{ configService.localeKeys?.subsc_btn_cmplt_pmnt_def }}</button>
      }
      @if (selectedPlan && oneTime == 0 && selectedPlan.user_type == 0 && selectedPlan.complete_payment!=1 && updatedPayment==0) {
        <button class="uk-button submit-btn" (click)="checkout(selectedPlan,'invoice')">{{ configService.localeKeys?.['plans.select_plan.text']}}</button>
      }
      @if (selectedPlan && oneTime == 1 && selectedPlan.user_type == 0 && selectedPlan.complete_payment!=1 && updatedPayment==0) {
        <button class="uk-button submit-btn" (click)="checkout(selectedPlan,'invoice')">{{ configService.localeKeys?.['plans.select_plan.text']}}</button>
      }
      @if (selectedPlan && subscribedPlanId && subscribedPlanId ==selectedPlan.subscription_id && updatedPayment==1) {
        <button class="uk-button submit-btn" (click)="updatePayment(selectedPlan)">{{ configService.localeKeys?.['account.update_payment.text']}}</button>
      }
      @if (selectedPlan && subscribedPlanId && subscribedPlanId !=selectedPlan.subscription_id && updatedPayment==1) {
        <button class="uk-button submit-btn" (click)="checkout(selectedPlan,'invoice')">{{ configService.localeKeys?.['plans.select_plan.text']}}</button>
      }
    </div>
  </div>
}

@if (step == 2) {
  <div>
    <div class="input-container">
      <div class="check">
        <img src="/branding/theme/assets/static_assets/ic-exclaimation-for-lbg.svg" alt="">
        <h2 class="uk-modal-title mt-0">{{configService.localeKeys?.['common_keys.are_you_sure.text']}}</h2>
        <p class="cancelled-text text-center">{{ configService.localeKeys?.plan_change_intimation_part1 }} {{ selectedPlan.title }}{{ configService.localeKeys?.plan_change_intimation_part2 }} {{nextBillingDate}} {{configService.localeKeys?.plan_change_intimation_part3 }} {{selectedPlan?.amount}} {{selectedPlan.plan_detail}}</p>
        <button id="iAgreeBtn" class="uk-button submit-btn" (click)="changePlan()">{{ configService.localeKeys?.i_agree }}</button>
        <button class="uk-button button-sec-close need-translation" (click)="step = 1" type="button">{{ configService.localeKeys?.back_to_plan_selection_button}}</button>
      </div>
    </div>
  </div>
}

<!-- Free plan steps -->
@if (freePlanStep === 2) {
  <div id="card-pay" class="form-card" [ngClass]="{'account-card': page=== 'account'}">
    <app-payment-method-type [step]="freePlanStep" (emitStep)="getSignStep($event)" [page]="page" class="common-bg" (emitCardMethod)="cardMethod($event)" [auth_head]="true"></app-payment-method-type>
  </div>
}
@if (freePlanStep === 3) {
  <div id="card-pay" class="form-card" >
    <div id="pay-detail" class="pay-detail-text">{{ configService.localeKeys?.channels_paymnt_details_desc || 'Please, enter your payment details below.'}}</div>
    <div class="pay-detail-text" [ngClass]="changePlan.oldUser ? 'subTitleTopPad' : 'subTitleBotPad'" id="pay-sub-title">{{ configService.localeKeys?.['plans.set_up_your_payment.text'] }}</div>
    <app-signup-step (emitStep)="getSignStep($event)" [page]="page" [backRoute]="" [currentStep]="paymentMethodLength > 1 ? '3' : '2'" [showChangePlan]="true"></app-signup-step>
    <app-card-payment [hidden] = "payment_type!='card'" [page]="page" (emitCardPayment)="cardPayment($event)" [payButton]="false" #changePlan></app-card-payment>
    <app-plan-info [idealBankValidationText]="true" [hidden] = "payment_type!='ideal'" [oldUser]="changePlan.oldUser" [showIntent]="false" [paymentIntent]="configService.localeKeys?.['plans.set_up_your_payment.text']"></app-plan-info>
    <app-ideal-payment-bank [hidden] = "payment_type!='ideal'"  (emitIdealPayment)="idealPayment($event)" [enableIdealPayment]="true"></app-ideal-payment-bank>
  </div>
}
@if (freePlanStep === 4) {
  <div id="pay-success">
    <app-account-created [paymentDialog]="paymentDialog" [btnText]="configService.localeKeys?.['welcome.start_watching.text']"
    [subTitleText]="subTitleText"></app-account-created>
  </div>
}

</div>